export enum TradeInIntegrationType {
  NONE = 'none',
  STAND_ALONE = 'standAlone',
  FULL = 'full',
}
